//addPendingClient

import axios from "axios";
import { toast } from "react-toastify";
import { getAuth } from "firebase/auth";
const AWS_CONNECTIONS_URL_STAGING =
  "https://bkhnm8s4hd.execute-api.eu-west-2.amazonaws.com/staging";
const INVITE_DISPATCH_URL =
  "https://utmn3d67vc6necc3falqmjeyju0utbua.lambda-url.eu-west-2.on.aws/";

export type InviteDispatchPayload = {
  email: string;
  name: string;
  emailCode: string;
  companyCode: string;
  preferredLanguage: string;
  extras: {
    inviteCode: string;
    // The address the invite is for — currently always the same as `email`
    // ("send on behalf" isn't implemented yet). Optional so the existing
    // bulk InviteDispatch caller doesn't have to set it.
    clientEmail?: string;
  };
};

export async function sendInviteDispatch(payload: InviteDispatchPayload) {
  const response = await axios.post(INVITE_DISPATCH_URL, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
}

// export async function fetchUserErrors(appUserIds: string[]): Promise<any> {
//     console.log("Fetching user activity for appUserIds:", appUserIds);
//   if (!Array.isArray(appUserIds) || appUserIds.length === 0) {
//     throw new Error("appUserIds must be a non-empty array");
//   }

//   try {
//     const response = await axios.get('https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/utilities/errors/byUser', {
//       headers: {
//         Authorization: `Bearer ${'domy-token'}`,
//       },
//     });    const items: ErrorLogItem[] = response.data.response.Items;

//     // Transform into a map grouped by userId
//     // const groupedByUserId = items.reduce<Record<string, ErrorLogItem[]>>((acc, item) => {
//     //   if (!acc[item.userId]) {
//     //     acc[item.userId] = [];
//     //   }
//     //   acc[item.userId].push(item);
//     //   return acc;
//     // }, {});

//     //return groupedByUserId;
//     return items;
//   } catch (error: any) {
//     if (axios.isAxiosError(error)) {
//       const message = error.response?.data?.message || error.message;
//       console.error("Axios error:", message);
//       throw new Error(message);
//     } else {
//       console.error("Unexpected error:", error);
//       throw new Error("Unexpected error");
//     }
//   }
// }

type FetchUserErrorsResponse = {
  success?: string;
  response?: any;
  error?: string;
};

// [
//     {
//       providerName: 'American Express',
//       country: 'GB',
//       status: 'active',
//       iconUrl: '',
//       createdAt: '2025-01-22T17:01:19.298Z',
//       updatedAt: '2025-06-04T22:30:21.979Z',
//       displayItems: {
//         name: 'American Express',
//         language: {
//           en: 'American Express',
//           fr: 'American Express',
//         },
//       },
//       categories: [
//         {
//           name: 'card',
//           status: 'active',
//           apiProvider: 'MONEYHUB',
//           api: {
//             moneyhub: 'c9182a1fe965f61f23bc6dea3e834618',
//             powens: 30,
//             yodlee: '',
//           },
//         },
//         {
//           name: 'cash',
//           status: 'active',
//           apiProvider: 'POWENS',
//           api: {
//             moneyhub: '',
//             powens: 30,
//             yodlee: '',
//           },
//         },
//       ],
//       groups: ['AME'],
//     }
//    ]

export type FinancialInstitutionsType = {
  providerName: string;
  country: string;
  status: string;
  iconUrl?: string;
  createdAt: string;
  updatedAt: string;
  displayItems: {
    name: string;
    language: {
      en: string;
      fr: string;
      [key: string]: string;
    };
  };
  categories: Array<{
    name: string;
    status: string;
    apiProvider: string;
    api: {
      moneyhub: string;
      powens: number | string;
      yodlee: string;
    };
  }>;
  groups: string[];
  yodleeKey?: string;
  moneyhubKey?: string;
  powensKey?: string;
};

type FinancialInstitutionResponse = {
  success?: string;
  response?: FinancialInstitutionsType[];
  error?: string;
};
export type FinancialInstitutionSearchResultsResponse = {
  success: string;
  response: FinancialInstitutionsType[];
};

type FinancialInstitutionToUpdate = {
  id: string;
  status: string;
  displayItems: {
    name: string;
    language: {
      en: string;
      fr: string;
      [key: string]: string;
    };
  };
  groups: string[];
  yodleeKey?: string;
  moneyhubKey?: string;
  powensKey?: string;
  categories: Array<{
    name: string;
    status: string;
    apiProvider: string;
    api: {
      moneyhub?: string;
      powens?: number | string;
      yodlee: string;
    };
  }>;
};

export async function fetchUserErrors(
  userId: string,
): Promise<FetchUserErrorsResponse> {
  try {
    const res = await axios.get(
      "https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/utilities/errors/byUser",
      {
        headers: {
          Authorization: `Bearer ${"domy-token"}`,
        },
        params: {
          userId,
        },
      },
    );

    return res.data;
  } catch (err) {
    console.error(err);

    let errorMessage = "An unexpected error occurred.";
    if (axios.isAxiosError(err)) {
      errorMessage = err.response?.data?.error || err.message || errorMessage;
    } else if (err instanceof Error) {
      errorMessage = err.message || errorMessage;
    }

    return {
      error: errorMessage,
    };
  }
}

// fetch last five updated institutions from AWS
export async function fetchLastUpdatedInstitutions(): Promise<FinancialInstitutionResponse> {
  try {
    const response = await axios.get(
      `${AWS_CONNECTIONS_URL_STAGING}/api/connections/last-updated`,
      {
        headers: {
          Authorization: `Bearer ${"domy-token"}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching last updated institutions:", error);
    throw error;
  }
}

//search financial institutions by provider name or country
export async function searchFinancialInstitutions(
  term: string,
  searchBy: string,
): Promise<FinancialInstitutionSearchResultsResponse> {
  try {
    const response =
      await axios.post<FinancialInstitutionSearchResultsResponse>(
        `${AWS_CONNECTIONS_URL_STAGING}/api/connections/lookup`,
        {
          term, // or 'term: term'
          searchBy, // 'providerName' or 'country'
        },
        {
          headers: {
            Authorization: `Bearer domy-token`,
          },
        },
      );
    return response.data;
  } catch (error) {
    console.error("Error searching financial institutions:", error);
    throw error;
  }
}

//update a financial institution
// put('/api/connections/update/:id'
export async function updateFinancialInstitution(
  institution: FinancialInstitutionToUpdate,
): Promise<FinancialInstitutionsType> {
  try {
    const response = await axios.put<FinancialInstitutionsType>(
      `${AWS_CONNECTIONS_URL_STAGING}/api/connections/update/${institution.id}`,
      { ...institution, updatedAt: new Date().toISOString() },
      {
        headers: {
          Authorization: `Bearer domy-token`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error updating financial institution:", error);
    throw error;
  }
}
export interface GetAllErrorTriageResponse {
  items: ErrorTriage[];
}

export interface ErrorTriage {
  id: string;
  processId: string;
  application: string;
  errorCode: string;
  errorMessage: string;
  errorWith: string;
  errorApi: string;
  firstSeen: Date;
  lastSeen: Date;
  occurrences: number;
  affectedUsersCount: number;
  priority: number;
  status: string;
  sampleErrorResponse: SampleErrorResponse;
}

export interface SampleErrorResponse {}

export async function getAllErrorTriage(): Promise<ErrorTriage[]> {
  try {
    const response = await axios.get(
      // `${AWS_CONNECTIONS_URL_STAGING}/utilities/errors/triage`,
      "https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/utilities/errors/triage",
      {
        headers: {
          Authorization: `Bearer domy-token`,
        },
      },
    );
    const data = response.data;
    return data.data.items;
  } catch (e) {
    throw e;
  }
}

// ErrorTriageUser.ts

export interface ErrorTriageUser {
  id: string;
  errorTypeId: string;
  userId: string;
  occurrences: number;
  firstSeen: string;
  lastSeen: string;
  status: string;
  user: {
    name: string;
    email: string;
  };
}

interface ApiResponse {
  // success: boolean;
  data: ErrorTriageUser[];
}
export async function getErrorTriageUser(
  errorHash: string,
): Promise<ErrorTriageUser[]> {
  try {
    const response = await axios.get(
      `https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/utilities/errors/triage/${errorHash}/users`,
      {
        headers: {
          Authorization: `Bearer your-token`, // Replace with actual token
        },
      },
    );

    // Based on your sample response, the data is in response.data.data
    // return response.data;
    return response.data?.data?.Items ?? [];
  } catch (e) {
    throw e;
  }
}

export interface UpdateErrorTriageParams {
  status?: string;
  priority?: number;
  notes?: string;
}

export interface UpdateErrorTriageResponse {
  success: boolean;
  message: string;
  data: {
    updatedFields: ErrorTriage[];
  };
}

export async function updateErrorTriage(
  errorHash: string,
  updateData: UpdateErrorTriageParams,
): Promise<UpdateErrorTriageResponse> {
  try {
    const response = await axios.patch(
      `https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/utilities/errors/triage/${errorHash}`,
      updateData,
      {
        headers: {
          Authorization: `Bearer your-token`, // Replace with actual token
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error updating error triage:", error);
    throw error;
  }
}

export interface UpdateErrorTriageUserParams {
  status?: string;
  notes?: string;
}

export interface UpdateErrorTriageUserResponse {
  success: boolean;
  message: string;
  data: {
    updatedFields: string[];
  };
}

// Function to encode the userTriageId for URL parameters
export function encodeUserTriageId(userTriageId: string): string {
  return userTriageId
    .replace(/#/g, "%23") // Replace # with %23
    .replace(/:/g, "%3A"); // Replace : with %3A
}

export async function updateErrorTriageUser(
  userTriageId: string,
  updateData: UpdateErrorTriageUserParams,
): Promise<UpdateErrorTriageUserResponse> {
  try {
    // Encode the userTriageId for URL parameters
    const encodedUserTriageId = encodeUserTriageId(userTriageId);

    const response = await axios.patch(
      `https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/utilities/errors/triage/user/${encodedUserTriageId}`,
      updateData,
      {
        headers: {
          Authorization: `Bearer your-token`, // Replace with actual token
        },
      },
    );

    console.log("Error triage user updated successfully");
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating error triage user:", error);
    throw error;
  }
}
export interface UserTelemetryItem {
  itemId: string;
  itemName: string;
  itemType: string;
  itemStatus: string;
  lastRefreshDate: string;
  lastCalculationDate?: string;
  itemBlocksCount?: Array<{
    blockType: string;
    blocksCount: number;
  }>;
}

export interface UserTelemetryConnection {
  connectionId: string;
  providerId: string;
  connectionStatus: string;
  apiProvider: string;
  lastUpdateDate: string;
  items: UserTelemetryItem[];
  status?: string;
  additionalStatus?: string;
  isLegacyConnection?: boolean;
  lastConsentTime?: string | Date;
  reminderValue?: string;
}

export interface UserTelemetry {
  id: string;
  userId: string;
  createdAt: string;
  deviceOs: string;
  version: string;
  eventData: {
    location: string;
    userIp: string;
    loginTime: number;
    deviceRes: string;
    details: string;
    preferences?: {
      primaryCurrency: string | null;
      additionalCurrency1: string | null;
      additionalCurrency2: string | null;
      primaryTaxResidency: string | null;
      additionalTaxResidency1: string | null;
      additionalTaxResidency2: string | null;
      activeFbar: boolean;
      activeGeoMonitor: boolean;
    };
    grantedLocationPermission?: boolean;
  };
  connections: UserTelemetryConnection[];
  connectionsFromProvider?: UserTelemetryConnection[];
}

export type TelemetryData = {
  version: string;
  eventData: {
    loginTime: number;
    notificationCategoriesEnabled: string;
    userIp: string;
    location: string;
    deviceRes: string;
    notificationsEnabled: boolean;
    details: string;
    lastReceivedNotification: string;
    preferences?: {
      primaryCurrency: string | null;
      additionalCurrency1: string | null;
      additionalCurrency2: string | null;
      primaryTaxResidency: string | null;
      additionalTaxResidency1: string | null;
      additionalTaxResidency2: string | null;
      activeFbar: boolean;
      activeGeoMonitor: boolean;
    };
    grantedLocationPermission?: boolean;
  };
  userId: string;
  deviceOs: string;
  id: string;
  createdAt: string;
};
export async function getUserTelemetry(
  userId: string,
): Promise<{
  connections: any[];
  connectionsFromProvider: any[];
  userTelemetry?: TelemetryData | undefined;
}> {
  try {
    const response = await axios.get(
      `https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/utilities/telemetry/${userId}`,
      {
        headers: {
          Authorization: `Bearer your-token`, // Replace with actual token
        },
      },
    );

    const items = response.data.data[0] ?? [];
    console.log(JSON.stringify(items));
    if (!items || items.length === 0) {
      return {
        connections: [],
        connectionsFromProvider: [],
        userTelemetry: undefined,
      };
    }
    const { version, eventData, deviceOs, id, createdAt } = items;

    const telemetryData: TelemetryData = {
      version,
      eventData,
      userId,
      deviceOs,
      id,
      createdAt,
    };
    return {
      userTelemetry: telemetryData,
      connections: items.connections ?? [],
      connectionsFromProvider: items.connectionsFromProvider ?? [],
    };
  } catch (e) {
    throw e;
  }
}

export const TELEMETRY_GROUP_BY_FIELDS = [
  "deviceOs",
  "version",
  "notificationsEnabled",
  "grantedLocationPermission",
  "deviceTimeZone",
  "activeFbar",
  "activeGeoMonitor",
] as const;

export type TelemetryGroupByField = (typeof TELEMETRY_GROUP_BY_FIELDS)[number];

export interface TelemetryGroupByFieldResponse {
  field: TelemetryGroupByField;
  totalUsers: number;
  groups: Record<string, string[]>; // group value -> list of userIds
}

export async function getUsersGroupedByTelemetryField(
  field: TelemetryGroupByField,
): Promise<TelemetryGroupByFieldResponse> {
  const user = getAuth().currentUser;
  if (!user) {
    throw new Error("No authenticated user");
  }
  const token = await user.getIdToken();

  const response = await axios.post<TelemetryGroupByFieldResponse>(
    "https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/utilities/telemetry/group-by-field",
    { field },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return response.data;
}

export interface TelemetryPercentagesResponse {
  totalUsers: number;
  metrics: Record<TelemetryGroupByField, Record<string, number>>; // value -> share of totalUsers (0-1)
}

export async function getTelemetryPercentages(): Promise<TelemetryPercentagesResponse> {
  const user = getAuth().currentUser;
  if (!user) {
    throw new Error("No authenticated user");
  }
  const token = await user.getIdToken();

  const response = await axios.get<TelemetryPercentagesResponse>(
    "https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/utilities/telemetry/percentages",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return response.data;
}

export async function getUsersLastLogin(
  userIds: string[],
): Promise<{
  usersWithLastActivity: Record<string, { loginTime: number }>;
  usersWithNoSnapshots: string[];
  status: "error" | "success";
}> {
  // DynamoDB rejects the whole request ("The AttributeValue for a key
  // attribute cannot contain an empty string value. Key: userId") if any id
  // is blank/undefined — which happens for pending or partially-migrated
  // users that have no app_user_id yet. Drop those (and dedupe) first.
  const cleanIds = Array.from(
    new Set((userIds ?? []).filter((id) => typeof id === "string" && id.trim() !== "")),
  );
  if (cleanIds.length === 0) {
    return {
      usersWithLastActivity: {},
      usersWithNoSnapshots: [],
      status: "success",
    };
  }
  try {
    const start = performance.now();
    console.log(`Fetching last login for userIds started at:  `, start);
    const response = await axios.post(
      `https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/utilities/latest-telemetry`,
      { userIds: cleanIds },
      {
        headers: {
          Authorization: `Bearer your-token`, // Replace with actual token
        },
      },
    );
    const end = performance.now();
    console.log(`Fetching last login for userIds ended at:  `, end);
    console.log(
      `Fetching last login for userIds took ${end - start} milliseconds.`,
    );
    const items = response.data;
    console.log(JSON.stringify(items), response.status, response.statusText);
    if (!items || response.status !== 200) {
      return {
        usersWithLastActivity: {},
        usersWithNoSnapshots: userIds,
        status: "error",
      };
    }
    const usersWithLastActivity: Record<string, { loginTime: number }> = {};
    const usersWithNoSnapshots: string[] = [];
    for (const userId of cleanIds) {
      if (!items[userId]) {
        usersWithNoSnapshots.push(userId);
      } else {
        usersWithLastActivity[userId] = {
          loginTime: items[userId].loginTime * 1000,
        };
      }
    }
    return {
      usersWithLastActivity,
      usersWithNoSnapshots,
      status: "success",
    };
  } catch (e) {
    toast.error("Error fetching users' last Activity");
    return {
      usersWithLastActivity: {},
      usersWithNoSnapshots: userIds,
      status: "error",
    };
  }
}
